import WeMembers from './We.Members.vue'

export default WeMembers
